import { action, actionOn } from 'easy-peasy';

import { trackEvent } from '~/utils';

export default {
  infoboxContent: null,
  setInfoboxContent: action((state, infoboxContent) => {
    state.infoboxContent = infoboxContent;
  }),
  onInfoChange: actionOn(actions => actions.setInfoboxContent, (_, { payload }) => {
    if (payload) {
      trackEvent('open_info', payload);
    }
  })
};
